import { useNuxtApp } from "#app";
import { BaseService } from "../base/base.service";
import { AdminConsoleRepository } from "./admin-console.repository";
import { ModelRegisterResponse, type IModelRegisterRequest } from "./dto/admin-console.dto";


export class AdminConsoleService extends BaseService {
  private adminConsoleRepository = new AdminConsoleRepository(this.api, this.configService);

  async register(params: IModelRegisterRequest): Promise<ModelRegisterResponse | undefined> {
    const { $functions } = useNuxtApp()
    let dataResult;
    try {
      const res = await this.adminConsoleRepository.register(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelRegisterResponse(resData.data)
        console.log('register', resData.data, dataResult)
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true
      });
      console.log(err, AdminConsoleService.name);
    }
    return dataResult;
  }
}
